import WdTitle from './WdTitle';

export default WdTitle;
